import type { TableColumnType } from "ant-design-vue";
import dayjs from "dayjs";

export const callsColumns: TableColumnType[] = [
  {
    title: "Empresa",
    dataIndex: "entity",
  },
  {
    title: "Campaña",
    dataIndex: "portfolio",
  },
  {
    title: "Canal",
    dataIndex: "channel",
  },
  {
    title: "Identificador",
    dataIndex: "identifier",
  },
  {
    title: "Tipo de llamada",
    dataIndex: "type_call",
  },
  {
    title: "Tipo de marcación",
    dataIndex: "type_dialing",
    customRender: ({ text }) => text || "-",
  },
  {
    title: "N° de contacto",
    dataIndex: "phone",
  },
  {
    title: "Resultado",
    dataIndex: "result",
  },
  {
    title: "Fecha y hora inicio",
    dataIndex: "call_start_date",
    customRender: ({ text }) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm") : "-"),
  },
  {
    title: "Fecha y hora fin",
    dataIndex: "call_end_date",
    customRender: ({ text }) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm") : "-"),
  },
  {
    title: "Usuario",
    dataIndex: "user_name",
    customRender: ({ text }) => text || "-",
  },
  {
    title: "Anexo",
    dataIndex: "annex",
    customRender: ({ text }) => text || "-",
  },
  {
    title: "Tiempo Total (Seg)",
    dataIndex: "duration_call",
    width: 180,
  },
  {
    title: "Tiempo hablado (Seg)",
    dataIndex: "spoken_time",
    width: 180,
  },
];
